(function (Vue, undefined) {
    new Vue({
        el: '#app',
        data: {
            siteId: '1275226121',
            // jqhl_id: '',
            refsrc: commonObj.utils.getQueryStrFn('refsrc') || 'none',
            userid: commonObj.data.userid || commonObj.utils.getQueryStrFn('curuserid'),
            token: commonObj.utils.getQueryStrFn('token'),
            reportid: commonObj.utils.getQueryStrFn('reportid'),
            options: {},
            dpr: window.devicePixelRatio || 1,
            loading: {
                text: '加载中',
                show: false
            },
            canvasImg: null,
            qrcodeImgURI: null,
            myChart: null,
            hasChartData: false,
            source: 'cb',
            dognutData: [],
            songInfoList: [],
            age: 20,
            voiceFeature: '声音倔强冷艳却不失温暖，让人沦陷的磁力音！',
            userInfo: {},
            isTestAgain:  commonObj.utils.getQueryStrFn('again') || 0, // 1为test again 0 为普通
            hasSaveImage: false
        },
        created: function(){
            const _czc = this._czc = window._czc || [], _this = this, ua = commonObj.browser.ua;

            const isAndroid = /(android)/i.test(ua);
            const isIOS = /(iPhone|iPad|iPod|iOS)/i.test(ua);
            const isQQorWeChat = /micromessenger/.test(ua) || /qq\//.test(ua);
            const isWX = /micromessenger/.test(ua);
            const isWeibo = /weibo/.test(ua);
            const isCB = /changba/.test(ua);
            if (_czc) {
                _czc.push(["_setAccount", this.siteId]);
                _czc.push(["_trackEvent", this.refsrc, commonObj.data.outChangba ? 'outCB-结果页' : 'inCB-结果页', 'loaded', 0, 'body']);
            }
            window.lazySizesConfig = window.lazySizesConfig || {};
            window.lazySizesConfig.loadMode = 1;
            FastClick.attach(document.body);

            if (isCB) {
                _this.source = 'cb';
            } else if (isWX) {
                _this.source = 'wx';
                _this.userid = localStorage.getItem('cbopid');
                _this.access_token = localStorage.getItem('cbaccesstoken');
            } else {
                _this.source = 'h5'
                window.location.href = `/njwap/yunying/audiotest/index/main`; 
            }
            
            _this.shareParams = {
                title: '测测你的主打歌',
                content: '测试你唱哪首歌最好听~',
                // thumburl:'http://cb.cdn.changbaimg.com/images/logo_300x300.jpg',
                thumburl: 'http://cbshowhot.cdn.changbaimg.com/-/8b8297bffe58395a/icon_300_300.jpg',
                link: `https://changba.com/njwap/yunying/audiotest/index/main`
            };
            let shareParams = {
                title: _this.shareParams.title,
                content: _this.shareParams.content,
                weibocontent: _this.shareParams.title,
                imageurl: _this.shareParams.thumburl,
                thumburl: _this.shareParams.thumburl,
                targeturl: _this.shareParams.link+'?refsrc=share&sharereportid=' + this.reportid
            };
            window.setShareUrlParams = function () {
                return JSON.stringify(shareParams);
            };
            commonObj.data.setWXShare = function (wx) {
                let shareData = {
                    title: _this.shareParams.title,
                    link: _this.shareParams.link + '?refsrc=wechatshare&sharereportid=' + _this.reportid,
                    imgUrl: _this.shareParams.thumburl,
                    desc: _this.shareParams.content,
                    success: function () {
                        _this._czc.push(["_trackEvent", '结果页-微信分享成功', 'loaded', _this.refsrc, 0, 'body']);
                    },
                    cancel: function () {
                        _this._czc.push(["_trackEvent", '结果页-微信分享取消', 'loaded', _this.refsrc, 0, 'body']);
                    }
                };
                wx.onMenuShareTimeline(shareData);
                wx.onMenuShareAppMessage(shareData);
                wx.onMenuShareQQ(shareData);
                wx.onMenuShareWeibo(shareData);
                wx.onMenuShareQZone(shareData);
            };

            if (!isIOS) {
                this.dpr = 1;
            }
        
            // 指定图表的配置项和数据
            this.options = {
                title: {
                    show: true,
                    text: '声音年龄',
                    subtext: this.age,
                    x: 'center',
                    y: '38%',
                    textStyle: {
                        color: '#c2484e',
                        // fontSize: (20/2) * _this.dpr,
                        fontSize: 20,
                        fontStyle: 'normal',
                        fontWeight: 'normal',
                    },
                    subtextStyle: {
                        color: '#c2484e',
                        // fontSize: (28/2) * _this.dpr,
                        fontSize: 28,
                        fontWeight: 'bold',
                    },
                },
                series: [
                    {
                        name: '音色',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        // avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: true,
                                fontSyle: 'bold',
                                color: '#421516',
                                // fontSize: (24/2) * _this.dpr,
                                fontSize: 24,
                            },
                        },
                        labelLine: {
                            normal: {
                                show: true,
                                length: (20/2) * _this.dpr,
                                length2: (20/2) * _this.dpr,
                                lineStyle: {
                                    width: (2/2) * _this.dpr
                                }
                            }
                        },
                        hoverAnimation: false,
                        hoverOffset: 0,
                        legendHoverLink: false,
                        color: [
                            '#c2484e',
                            '#d7bf9c',
                            '#e8d8c1',
                        ],
                        itemStyle: {
                            borderColor: '#f7f1e9',
                            borderWidth: (2/2) * _this.dpr,
                            borderType: 'solid'
                        },
                        data: this.dognutData
                        // data:[
                        //     {value: 45, name: '御姐音50%'},
                        //     {value: 20, name: '萝莉音50%'},
                        //     {value: 10, name: '御姐音350%'},
                        // ]
                    }
                ]
            };
        },
        mounted: function(){
            this.$nextTick(() => {
                this.initData();
            })
        },
        methods: {
            initData: function () {
                const _this = this;
                let params = {};
                this.loading = {
                    text: "加载中...",
                    show: true
                }
                if (_this.reportid) {
                    params = {
                        source: _this.source,
                        userid: _this.userid,
                        reportid: _this.reportid
                    }
                }
                else {
                    if (_this.source == 'wx') {
                        params = {
                            source: _this.source,
                            userid: localStorage.getItem('cbopid'),
                            access_token: localStorage.getItem('cbaccesstoken')
                        }
                    }
                    else if (_this.source == 'cb') {
                        params = {
                            source: _this.source,
                            userid: _this.userid,
                            token: _this.token
                        }
                    }
                }
                console.log('params');
                console.log(params);
                axios.get('/api/sound/soundDetection/soundDetection/getresult', { params }).then((res) => {
                    if (res && res.data && res.data.code === 1) {
                        console.log(res.data.data);
                        let distribution = res.data.data.distribution;
                        _this.songInfoList = res.data.data.songinfo;
                        _this.voiceFeature = res.data.data.sounddes;
                        _this.userInfo = res.data.data.userinfo;
                        _this.options.title.subtext = res.data.data.userinfo.age + '岁';
                        // _this.userInfo.headphoto = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAASABIAAD/2wBDAAcFBQYFBAcGBgYIBwcICxILCwoKCxYPEA0SGhYbGhkWGRgcICgiHB4mHhgZIzAkJiorLS4tGyIyNTEsNSgsLSz/2wBDAQcICAsJCxULCxUsHRkdLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCwsLCz/wAARCACEAIQDASIAAhEBAxEB/8QAHAAAAQQDAQAAAAAAAAAAAAAAAAMFBgcBAgQI/8QASxAAAQMDAwEFBQMHBgwHAAAAAQIDBAAFEQYSITEHE0FRYRQicYGRMqHBFRcjM0JSsRYkcrLR0jQ1Q0VTVZKTlKLi8ERjc4OFs8L/xAAZAQADAQEBAAAAAAAAAAAAAAABAgMEAAX/xAAtEQACAgEDAgMIAgMAAAAAAAAAAQIREgMhMSJRBBNBFDJxobHR8PGBkTNSYf/aAAwDAQACEQMRAD8AvOiqlt/beFzEi426O1GwdymHlrX04wCkA8+op2/PXpvH+DXD/YR/frRijPkid3AzhCWbcI6pIxtTIJCD55I5FQjUGrtW6YhpmXG0272cuBve06o8nOB5+B8K1T20aaUoDupqfVSE/go0zav17pPV1kTbnZNwipDqXd7bCFHjPHKvWniqe6Ek0+GWlbpzVztkacyf0chtLifQEZxXTVf9n2rbGtiNpy3yJr6mUrWHZTaUDbknHCj4mp2JTKjgOD6UjVMdPYVo8KwlSVDKSD8azQCFFFFccFFFFccFRq56sVbL57M5FUYyQApWMKJ8x5ipLXJcbXEu0buZTQVj7KhwpJ8wKSV1uFV6jJqjWTVm0mq8W5CZ6itKEIB8T1z4jArqsWq4t30sxen0exodKkltR3EFKiMDgZ61U+t7TNsl2RHhX15DLy0oUllRTjOQN23xHlz+FP2kLU5MDdvk3Z2QG+e8fWVKOeSlOfUmpvXjSil1FFpP3vWqJS/rN4vK9njthvw35J+6ipHFtMGJHS03HbIHipIJJ8yaKOM+4trseXe8HjisFQzU8/NaP9cH/h/+qtHuzViOAXb1t3cD+b5J+W7wrU/ExXLMHs0+xBw5g8HwrcPHP2qmQ7PIp/zyv/hD/bR+b2GlSQq9qTuOBuikD6lVKvGaf+wfZdTuRFEx1pze06ttfTckkGpBYb9cWpB/nrpTjkFWf408fmvRn/Gyv9x/1Up/IlmwpE9+aZUdpxBcaDGCpO8Ajqc9elWj4iLdWSn4adXQ86d1XMN/iMqf7xp9xLakn1OKtGqWnTIN31HZJUOE7EDE2KPeQEglTqPAeXIPyq6yaXX5W1F/CrpdOzWis4ozUDUa0YrbFGK46jGaiWo75cUzza4TLjS1Y98DKlg/u46D/vipfmte6QXQ4UJ3gbQrHOPLFJNOSpOgrZlfv9nqJdjmO3Q98/3DhZZCsJSvacFRHUg/L4U3aT0NMi6KirQ4kzUKWVoCuD7xxtPgcYqS641nBsdmfYjz4Sri4tLAZW8kqQVcFSk5zgCk+yq6SrxoZqZLWhTinnEgITtCQD0/H51PyKWKXT87KZ+vqcjOrrnBb9nfaS442cEughQ9DRU2egQ5LnePxWXV4xuWgE0UvlzXEgWuxTzmt5Qf3piNiPn7KgrOM4+10z08PCpLHlMzgxLbz3a2ioZHI55H3VCF6RvAfEcR0LbB4dC0hPUHPXd1A8KmcOELXAZiJXuLTKsq8znJP1JptRQaVCaTnbsja+1OxoeUgw7iNpI5CP7K64OsrVqJx6DGakod7or/AEyU4Ix4Y8eaqrTkSNOvWJ0aTJYKFKcTHPv5/eGfjVm2Oz6WhuuSba7c0TSyQhuUUFKkdCfdHXjzqj04uLdBzqVWTFBOxOfKtbg73EDvQAdjrRwf/UTWyP1SfgKy+wmUyhhRIC3mgSOo/SJqMH1Iaa6UNtyuLEpEJAioQ4bhEIUnB/8AEN+lWTVVatSbVqnT8CN7zMiWwtwr6+6+3jGMCrXIrdrNWqMvh01F5GmaMVtijFQs00a1ms4oxXUdRiis1k11nWUFrbQ2o3+0OXcWbU4/AVJTIDqCCnbhOeM+G08Va2gLhBuelkv24gsB1SeEFHPGeKjWstbOXCXM01boUsOR5Dbcp9LiUJU3wpSUnIOSOPCnzsysaLDpVcZD6nyuQpZWoYPQDpn0qUpQeorfVT2/orhqR07rpfoS/FFZoqpMg2eK4JsgNz2mSM942rB+BNdueabbiB+VIp8e7cx91ZFyOVFYC3BuAcD5BUg5S0kq+uKncBaWEIkqSVKEc9PEk+vwqB2Fxxub37YCUoQQ4cZwDgfj99S+HcociX7Ih0OvJYUeOcAY6mvRroZjlvNFgt5LDef3R/Clhwtg/wDntf8A2JpBr9Q3/RH8K2lyW4MP2t39WwtDivgFgisEfeRrfDGXtAKBrfTRKST7QyB72MfzhBzjx6ValVVqHUluvz0HuClQblxkhJwTkvoJxj0TVq1t1U1SRl0WmnRijFFFRNAVnFYrNE4xWaKK44rvUHZpOlXy5Xiz3wRXpuFmO8xuRvAxndnI+grfscdu7uk5P5VQ5kSlbFPKV3h91PGCOnkc+dWCelQzsvvbd803KfbZW0G5amyFHPISk5+6pu801H4srm5QxlLjhfQmdFFFOSIEFo8Vp+tcshpl64sLKxlLawOfPbVNCdB/1Qz/AL1z+/SrEpkF19qyxltttnvd61KABIAPJ8yOlL5T7P5fcktZfn6JpZdFzrHMkuxrjGWHmHWE708jcnAV8QcH5VwWnQj+nnn5r09h4dypASjIOT8fhUY9vgKUSbKwMnoHXAP61Kx5cBbykptLSCWnOQ64f2FeZqjU6/X3FWpG/wA+xc8dSTFZO4fYHj61V2tNfSHLtJtkd1oQWstONgZLpGQcny6Ywfj6NMJ+3rbbC7U10GSXnP7ai17h+zXR5TaMMOqLjW0lQCSeBn06fKlUMXbKwnndEt0w2/fVhUB5ll6JIbeLLjhBVhQKQjOSckHjzIr0p7QsgHJ5GcV5h0W2qzgXiQyCkOtrQFddqVZUcfLg+hp+v/aveZ90LDchEaCDgCAshShnxWU5+gFaUnPdktotqKPQHfOc4FYL6/M1SV311pybpN5pmZP/ACqWEhK1qcJ3jGec/GmnR+qLaqE5HvlylW1xsDuJkd54OKOTndglJwCOoo4MXOXY9BF9z96te/Xz75FVRY+1qJCcEK9T/bm95Dc1hog4HQrT8McgfKprB1vpeelPdXuKd3RK17D9FZoYhzJD7S5j7QrIfdHiTXM1JiOoCmng82SAC2oEc/WlVBCle4CPvoUGyMX/ALULBpx9yPLluOyWzhTLLZUofM4H3UzaUv8AY9JSWrA0h9ly5vd81+2kqVhOM5yOlV32r2C4MaznTUQZCobu1YeS2Sk+6nPPwrl09pG9xdYWjYwVYfbeU62CtLSd495XT45rPOvNj1Vzt3/ReH+OTrtv2/Z6QMpf7wopLuknqsA+PWitOxntHl/ApRsJUHklIOGioehCkj8TSdZQ4lC1AnlbZQB65B/Ci+DLHkAPSlYuPaR6oc/qKpLNdtmiiff4UMqKRIcDRI6gK4z99c+Doe8jr0xpq86iLabbBcdbTgKdPutp+Kjx+NT+P2ZxI7KWpM9xxxAwsBAKN2ecemal7CE22CzChDuIzSdqEI4AFZ3+6SfnQcU1UzXCLg8o8EWumhQ/ZH27eHJchLRwjABPlg1T72mJEJpbc4OxZiRuLTicbeCRkHnHHXoK9GsOracJQop4wc03XDTdu1UlDVy70Fs5DrSyhWMdCR1HrXbLYKju2uWeaFLCSUr3JUOoIxilESGk4yVDHlivSyuzu1OKK3LxenFKOSTNXk/fWyez60D/ADlej/8AIO/21OytM82d9HcxukL4/eG6umHGiz57DCHdoKVFZQjk7Uk8ZJ5OMfhXoz+QFjGAqfevgbg9/erSR2baSkutvS2LhJW19hb054lPwJXxXZIFIppl6fpC9su2Z9TxkZaKHAHT4dCAOueMAdDXoaDFkrt0dTqV94ptJUF4Cs45z5GmqFo3TsJ9UiIxNS6vG5YnSCVYzjP6TnGT9ajPaFqb+S7zcmNF9pcS2hDRWSsN8ryr3sjdwBk84oT1X6KwR07e5Yfsr27O36kVX/ZdcblfUXpyT3IaZld2gIOCCBzwc8fZ6etV0x2rXFzUMGc6gktLSHEtstJLqM+8nG3PIJxzwan/AGeaj7y3z0w9POPlEghwtuNJwr1yoZNRcm5Rbjvv/BVQSjJJ7fQsURnwP2fqiiq/k9slojvqa/JjuU8H30HB8uFCiq5k8Clt9LRYbc1ZLlwYh7P9KlR3Z8toPlTTbLkw/c4zdxc9mhrcAedQkqKEeJA5zU/naLtabXJl2y6vy0CKiRFeLWGnlFSwpOfAjakY6gmqZJmZaUkMjVghNq3HUcVWR0KXSP6tPekrTEb1lbltXiJJUhZWG0IcCjhJPinHhiq5N0fScFCR8c1M+yt5ybrlpSkp/QsuOcfDb/8AquyXA/lyu2i7lHJ+FafsqBoTkOuqPHI+fSk1KyheB6UzKtijqlJjuqT12HH1pG3pj3Zp2O9lxpa1IWlKik8HjkYPhXJe5qo9neUg7SE8qPQV02eMmK8txK1ZcUlZBwADtxxjzxn40GFDxHtsKJGSwy0pLaOgK1K9epFIR7BaYslUhmEhDqk7CrJyRxx19BVdWftORYtlgnQZ06TGkOR+8SoOLUA4pIGOqiAAOvOKtVtRdaQsJUncAraoYI9CPKs/lw32W/JTKXFjVL0rYbhIL8u1R33SANy05ODXTLs1rnRyxKgsvtEglC05HFOKI63DgfU8A10NxooXtckIUsc7Qo0HGCq0tuP+AtjJCsVotrSmodujx21K3FKEAAnz+6q37TNNeyfprTZo7Jk8KkJSEgZ3bsqPAJ3D/vpckm42m1x1PyJMaO2nqtxxKQPmTTRcdXaXegKE662xyIrGUrWl1J8RxyKlKMJJuPL/AD+SkLT+B53sun49su0Sfd50X2aO4l9bLZ3rcSk5KQOOuPOrP7DgxKt9+e70pQqbuTkYJBGRXTKsMeNpm8WmHEgSY8hh8wXiEBTBUTtTnGSnChg9QQQeMGo52XXZvSMW5RJMh1x8SkhbMaM4+kge6rKko4I6jnnHzpNDUytZ5MbUS2ajRWVyWE3aYByA8v8AiKKkA0cu6Lcmt36zMIfcUsIffW24PePVJRzRRfidJOnJAUH2Ga06RaudguV4XdEtQrc4EOFLYWsgkAK2bgQDkff5GrysTF20x2f29qG1DkMx2FOrdmPFgpQcrztSlXgfPwqlLAVM6I1bGLLweeTGbSA0o8peypJIGAceVX3D1FY3LIxGWuaN0dLatkR7I93HB2Vdac3LJN/DavpfzJOceDzq0u1Xa9yptx9ojNSHVrS3ETu2qUrIHI6dfXjpVk9l1hjN316bHt95hoTGVtemhIbdBUBtGEjnjI58DURu2i7lZr8p6wtv3CGh0OMlcVWQAcgLStIBx08j6U8QNSams256Xp2DBYPDkn2MtqBJyOQcDKseGPhTPRllm7AtSL6U0W/LacbWQtSSCNyNowQCB1PxBrjKH1AgKShOeoGSariydpi7fLeY1Kt5aX8OtPJG7uxyCkgeHGRj8af3e1LSjTJKJzrx67UMLB/5gBWiMlWxOcGpUOd+ZU5Z3953lCcgdBTzAU4AC6lKVbQCEnI4JqqLz2rflJYhWq3ltDygguyDlXJ8EjgH5mraYxnjnNdKSdWCKa5Gyw2CNqubcLjIWGBHmPx21RJi2V+64oHelAGFYwc5OQRUsgaWjW1K0x3X195gq72Y66Tj+ko4pl0pppNikXWW64l5dwmrlN4H6pKvDnx5OKknfJHTdWWUItYtWy6buxOXpuy3COhN0t7UnuiTh0FQHrSUK0aVtrhcg222xnCNpW2wlKiPLOPSuoSR4FX0pPvGf9Bn/wBvP4UI6cUsUtjm3dnS7b4byBuiMOt/ulsEH50m85Ct8Rx1MNCUtIKtqEAE4HQCtDLISEoQ8kDwDagP4Vxy1vPsLaZMqO4oYDrbZKk+oyk1y04rag2yA9onaeBYFW21w/001vC3XNq0soPXIGfe9D061XfZre79ZNRBu2Nqkoe4dhHID4HlxgKA5ycdOakWpeze8PS3p7sholwlbinSpoHr73KevnTI3Z02xbJjXi2JlIX3iHkvOqUceHAKSPlVMYx2oS2/QY9SWC6Wi/yI8uItLild6MAqBCuRgjg+XHiBRUyk3m+SH1OpvVlZB6JCFEf8yCfvopLXdf2PT7FUocX76d5wo5Iz1rpbkPcDvl4/pGiinQpj2uQP8sv/AGjWq3XHUFK3FKB8CaKK6w0IvE+6PIYFJ9DRRQAAPjVsWnW13Z0QHgppbzaQ2lxaSVeWTzyaKKZAJH2Wauvd1v7kGdNVIY7hTgSsD3VAp6EfCraDh9D8qKKlqbMtDgUAC0nI+lIFRBooqY6AKIrdBNFFcgizYEllTboCk+tUx2i6OtEe6RbhGYMZ9yWGnC1gJWOTkjGM8dfrRRTr3SEuCG3TTFvTLBAWnKQTtIA6kdAPSiiipwewjZ//2Q==';
                        if (distribution && typeof distribution === 'object') {
                            Object.keys(distribution).forEach((key)=> {
                                _this.dognutData.push({
                                    name: `${key} ${distribution[key]}%`,
                                    value: distribution[key]
                                })
                            })
                            console.log(_this.dognutData);
                            // 画饼图
                            _this.$nextTick(()=>{
                                _this.createDognut(_this.options);
                                // _this.loading.show = false;

                                if (!/changba/.test(commonObj.browser.ua) || !/android/.test(commonObj.browser.ua)) {
                                    setTimeout(() => {
                                        _this.genImage(()=> {
                                            console.log('初始化生成图片');
                                            _this.loading.show = false;
                                        })
                                    }, 1500);
                                }
                                else {
                                    _this.loading.show = false;
                                }
                                // 预先生成长图
                                
                            })
                        }
                    }
                }).catch((err) => {
                    alert(err);
                })

                
            },
            testAgain: function () {
                this._czc.push(["_trackEvent", commonObj.data.outChangba ? 'outCB-再测一次按钮-点击' : 'inCB-再测一次按钮-点击', 'loaded', this.refsrc, 0, 'body']);
                this.isTestAgain = 1;
                window.location.href = `/njwap/yunying/audiotest/index/main?curuserid=${this.userid}&token=${this.token}&again=${this.isTestAgain}`; 
            },
            goSongChannel: function () {
                if (/changba/.test(commonObj.browser.ua)) {
                    this._czc.push(["_trackEvent", `inCB-点歌台-点击`, 'loaded', this.refsrc, 0, 'body']);
                    window.location.href = "changba://?ac=musicboard"; 
                }
                else {
                    this._czc.push(["_trackEvent", `outCB-点歌台-点击`, 'loaded', this.refsrc, 0, 'body']);
                    commonObj.utils.openApp(false, "https://changba.com/njwap/yunying/audiotest/index/main", $('.open-mask'), 'http://changba.com/d');
                }
            },
            gotoRecord: function (songid) {
                if (/changba/.test(commonObj.browser.ua)) {
                    this._czc.push(["_trackEvent", `inCB-主打歌${songid}-点击`, 'loaded', this.refsrc, 0, 'body']);
                    window.location.href = "changba://?ac=record&song_id=" + songid;
                } else {
                    commonObj.utils.openApp(false, "https://changba.com/njwap/yunying/audiotest/index/main", $('.open-mask'), 'http://changba.com/d');
                }
            },
            createDognut: function (options) {
                const ctx = document.getElementById('canvas');
                this.myChart = echarts.init(ctx);
                ctx.style.width = (600 / 2) * this.dpr + 'px';
                ctx.style.height = (260 / 2) * this.dpr + 'px';
                // 使用刚指定的配置项和数据显示图表。
                this.myChart.setOption(options);
            },
            // 上传图片 废弃
            uploadImage: function() {
                let fd = new FormData();
                fd.append('userid', this.userid);
                fd.append('share_img', this.canvasImg);
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }

                // 上传图片
                axios.post('/api/sound/soundDetection/soundDetection/uploadResultImage', fd, config)
                .then((res) => {
                    if(res && res.data && res.data.code == 1){
                        this.loading.show = false;
                        if(!/changba/.test(commonObj.browser.ua)){
                            window.location.href =  `/njwap/yunying/audiotest/image/main?url=${res.data.data.share_img}`;
                        }else{
                            window.location.href = 'changba://?ac=saveImage&imageURL=' + encodeURIComponent(res.data.data.share_img) + '';   
                        }
                    } else{
                        this.loading.show = false;
                        alert(res.data.msg);
                    }
                })
                .catch((err) => {
                    this.loading.show = false;
                    console.log(err);
                })
            },
            
            saveImage: function () {
                this.loading = {
                    text: "正在生成长图",
                    show: true
                }
                // if (!this.canvasImg || this.canvasImg == null) {
                //     console.log('genImage');
                //     this.genImage(this.uploadImage);
                // }
                // else {
                //     this.uploadImage();
                // }

                if (!/changba/.test(commonObj.browser.ua)) {
                    if (!this.canvasImg || this.canvasImg == null) {
                        this.genImage(() => {
                            this.loading.show = false;
                            this.hasSaveImage = true;
                            scrollTo(0,0);
                            console.log('not yet and gen again');
                        });
                    }
                    else {
                        console.log('has gen image');
                        this.loading.show = false;
                        this.hasSaveImage = true;
                        scrollTo(0,0);
                    }
                }
                else {
                    if (!this.canvasImg || this.canvasImg == null) {
                        console.log('cb not yet and gen again');
                        if (/(Android)/i.test(commonObj.browser.ua)) {
                            this.genImage(this.uploadImage);
                        }
                        else {
                            this.genImage(() => {
                                window.location.href = 'changba://?ac=saveImage&imageURL=' + encodeURIComponent(this.canvasImg) + '';   
                                setTimeout(() => {
                                    this.loading.show = false;
                                }, 1000);
                            });
                        }
                    }
                    else {
                        console.log('cb has gen image');
                        if (/(Android)/i.test(commonObj.browser.ua)) {
                            this.genImage(this.uploadImage);
                        }
                        else {
                            window.location.href = 'changba://?ac=saveImage&imageURL=' + encodeURIComponent(this.canvasImg) + '';   
                            setTimeout(() => {
                                this.loading.show = false;
                            }, 1000);
                        }
                        
                        // this.uploadImage();
                    }
                }
                
            },
            genImage: function(cb) {
                this.drawImage(cb);
            },
            drawImage: function(cb) {
                const _this = this,
                canvas = document.getElementById('canvasd'),
                ctx = canvas.getContext('2d'),
                base = _this.dpr;

                canvas.width = 750*base;
                canvas.height = 1598*base;
                this.logg('start drawImage');
                let bg = new Image();
                bg.setAttribute('crossOrigin', 'anonymous');
                bg.src = '//cbshowhot.cdn.changbaimg.com/-/32857814eeaa590a/bg_out5.jpg';
                bg.onload = () => {
                    this.logg('drawImage bg');
                    ctx.drawImage(bg, 0, 0, canvas.width, canvas.height);

                    if (!/changba/.test(commonObj.browser.ua)) {
                        ctx.fillStyle = "#e8d8c1";
                        ctx.font = 24*base + "px bold PingFang";
                        let saveTxt = '长按保存图片分享';
                        ctx.fillText(saveTxt, (750*base - ctx.measureText(saveTxt).width)/2, 100*base); 
                    }
                   
                    // 画头像
                    let avatarImg = new Image();
                    avatarImg.setAttribute('crossOrigin', 'anonymous');
                    // avatarImg.src = 'data:image/jpeg;base64,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';
                    avatarImg.src = this.userInfo.headphoto || '//cbshowhot.cdn.changbaimg.com/-/905bab36808f28a7/avatar.png';
                    // avatarImg.src = this.userInfo.headphoto.substring(5, this.userInfo.headphoto.length);
                    avatarImg.onload = () => {
                        this.logg('drawImage avatar');
                        ctx.save();
                        ctx.beginPath();
                        // 画圆，将头像剪切
                        ctx.arc(375 * base, 286 * base, (120/2) * base, 0, 2 * Math.PI, true);
                        ctx.closePath();
                        ctx.fill();
                        ctx.clip();
                        ctx.drawImage(avatarImg, (375-120/2) * base, (286-120/2) * base, 120 * base, 120 * base);
                        ctx.restore();

                        ctx.fillStyle = "#421516";
                        ctx.font = 28*base + "px bold PingFang";
                        let name = this.userInfo.nickname || '小唱用户';
                        ctx.fillText(name, (750*base - ctx.measureText(name).width)/2, 380*base); 

                        let dognutDataURL = this.myChart.getConnectedDataURL();
                        const dognutImg = new Image();
                        dognutImg.src = dognutDataURL;

                        dognutImg.onload = () => {
                            this.logg('drawImage dognut');
                            ctx.drawImage(dognutImg, 70 * base, 530 * base, 600 * base, 260 * base);

                            ctx.fillStyle = "#421516";
                            ctx.font = 26*base + "px bold PingFang";
                            let txt = this.voiceFeature || '声音倔强冷艳却不失温暖，让人沦陷的磁力音！';

                            if(ctx.measureText(txt).width > 560*base) {
                                let txt1 = txt.substring(0, 18);
                                let txt2 = txt.substring(18, txt.length);
                                ctx.fillText(txt1, (750*base - ctx.measureText(txt1).width)/2, 440*base); 
                                ctx.fillText(txt2, (750*base - ctx.measureText(txt2).width)/2, 475*base); 
                            } 
                            else {
                                ctx.fillText(txt, (750*base - ctx.measureText(txt).width)/2, 470*base); 
                            }

                            ctx.fillStyle = "#421516";
                            ctx.font = 24*base + "px bold PingFang";
                            let currTime = this.getCurrTime();
                            let testTime = `检测时间: ${currTime}`;
                            ctx.fillText(testTime, (750*base - ctx.measureText(testTime).width)/2, 1345*base); 

                            let pArr = [];
                            this.songInfoList.forEach((value, key, arr) => {
                                let tempPromise = null, feature= '声音冷艳', x = 70, y = 970;
                                if (key === 1) {
                                    y += 110;
                                    feature = '适合你的分贝';
                                }
                                if (key == 2) {
                                    y += 220;
                                    feature = '适合你的音色';
                                }
                                if (key == 0) {
                                    feature = '适合你的音域';
                                }
                                tempPromise = this.drawRankItem(value, base, ctx, x, y, feature);
                                pArr.push(tempPromise);
                            })
                            // 二维码
                            pArr.push(this.drawQRCode(ctx, 316, 1400, base));

                            Promise.all(pArr).then(() => {
                                // blob用作二进制上传
                                if (/changba/.test(commonObj.browser.ua) && /android/.test(commonObj.browser.ua)) {
                                    this.canvasToBlob(canvas, (blob)=> {
                                        this.canvasImg = blob;
                                        this.logg('drawImage to blob');
                                    });
                                }
                                else {
                                     // 直接本地生成base64
                                    this.canvasImg = canvas.toDataURL("image/png");
                                    const img = new Image();
                                    img.src = this.canvasImg;
                                    img.style.width = "100%";
                                    document.getElementById("pic").appendChild(img);
                                }
                                
                                this.logg('drawImage done');
                                // this.loading.show = false;
                                typeof cb === 'function' && cb();
                            }).catch((err)=>{
                                this.loading.show = false;
                                console.log(err);
                            })
                        }
                    }
                    
                }
            },
            // DataURL转Blob对象
            dataURLToBlob: function(dataurl){
                var arr = dataurl.split(',');
                var mime = arr[0].match(/:(.*?);/)[1];
                var bstr = atob(arr[1]);
                var n = bstr.length;
                var u8arr = new Uint8Array(n);
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {type:mime});
            },
            // canvas转Blob
            canvasToBlob: function(canvas, cb){
                const _this = this;
                cb(_this.dataURLToBlob(_this.canvasToDataURL(canvas)));
            },
            // canvas转dataURL：canvas对象、转换格式、图像品质
            canvasToDataURL: function(canvas, format, quality){
                return canvas.toDataURL(format||'image/jpeg', quality||1.0);
            },
            // draw songList
            drawRankItem: function (songdata, base, ctx, x, y, feature) {
                return new Promise((resolve, reject) => {
                    this.logg('drawImage rankitem');
                    this.drawRoundedRect(ctx, x*base, y*base, 607*base, 90*base, 45*base, true, false);
                    let avatarItemImg = new Image();
                    avatarItemImg.setAttribute('crossOrigin', 'anonymous');
                    console.log(avatarItemImg.crossOrigin);
                    avatarItemImg.src = songdata.icon || '//cbshowhot.cdn.changbaimg.com/-/905bab36808f28a7/avatar.png';
                    avatarItemImg.onload = () => {
                        ctx.save();
                        ctx.beginPath();
                        // 画圆，将头像剪切
                        ctx.arc((x + 90/2) * base, (y+ 90/2) * base, (90/2) * base, 0, 2 * Math.PI, true);
                        ctx.closePath();
                        ctx.fill();
                        ctx.clip();
                        ctx.drawImage(avatarItemImg, x * base, y * base, 90 * base, 90 * base);
                        ctx.restore();

                        ctx.fillStyle = "#421516";
                        ctx.font = "700 " + 28*base + "px PingFang";
                        let username = songdata.name || '小唱用户';
                        if (username.length >= 8) {
                            username = username.substring(0, 8) + '...';
                        }
                        ctx.fillText(username, 190*base, (y+ 90/2 + 28/2)*base); 

                        ctx.font = 28*base + "px PingFang";
                        ctx.fillText(feature, 215*base + ctx.measureText(username).width, (y+ 90/2 + 28/2)*base); 

                        resolve();
                    }
                })
            },
            // 圆角矩形
            drawRoundedRect: function(ctx, x, y, width, height, r, fill, stroke) {
                ctx.save(); 
                ctx.beginPath(); // draw top and top right corner 
                ctx.moveTo(x + r, y);
                ctx.arcTo(x + width, y, x + width, y + r, r); // draw right side and bottom right corner 
                ctx.arcTo(x + width, y + height, x + width - r, y + height, r); // draw bottom and bottom left corner 
                ctx.arcTo(x, y + height, x, y + height - r, r); // draw left and top left corner 
                ctx.arcTo(x, y, x + r, y, r);
                if (fill) { 
                    ctx.fillStyle = "#e8d8c1";
                    ctx.fill(); 
                }
                if (stroke) { ctx.stroke(); }
                ctx.restore(); 
            },
            drawQRCode: function (ctx, x, y, base) {
                return new Promise((resolve, reject)=> {
                    this.logg('drawImage qrcode');
                    let qrcodeImg = new Image();
                    qrcodeImg.setAttribute('crossOrigin', 'anonymous');
                    qrcodeImg.src = document.getElementById('qrcodeImg').src;
                    qrcodeImg.onload = () => {
                        console.log(1);
                        ctx.drawImage(qrcodeImg, x * base, y * base, 120 * base, 120 * base);
                        resolve();
                    }
                })
            },
            // 获取当前日期
            getCurrTime: function () {
                let date = new Date();
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();

                return `${year}/${month}/${day}`
            },
            // 日志打印
            logg: function () {
                console.log.apply(console, arguments);
            }
        }
    })
})(Vue);
